export default __webpack_public_path__ + "b1e3411cacc0fc7817cdc98c2baaf7a2.png";